import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M8.174 2.373a3.055 3.055 0 0 1 3.652 0l5.088 3.794A2.7 2.7 0 0 1 18 8.33v8.416c0 .82-.665 1.485-1.485 1.485H3.485c-.82 0-1.485-.664-1.485-1.485V8.331a2.7 2.7 0 0 1 1.086-2.164l5.088-3.794Zm2.815 1.123a1.655 1.655 0 0 0-1.978 0l-5.07 3.78 4.807 5.172c.418.415.859.585 1.258.585.398 0 .838-.17 1.257-.585l4.797-5.172-5.07-3.78ZM16.6 8.752l-3.254 3.509 3.254 3.888V8.752Zm-1.253 8.08-2.96-3.536-.107.115a.82.82 0 0 1-.018.019c-.642.642-1.428 1.002-2.257 1.002-.827 0-1.614-.36-2.256-1.002a.954.954 0 0 1-.018-.019l-.11-.118-2.963 3.54h10.689ZM3.4 16.154l3.26-3.895L3.4 8.751v7.403Z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponent);
export default ForwardRef;
//# sourceMappingURL=EmailOpenIcon20.js.map